import { css, type Theme } from '@emotion/react';

export const lessonDrawerHeader = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 5px;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.gray[100]};

  @media (min-width: ${theme.breakpoints.medium}) {
    padding: 10px;
  }
`;

export const lessonContentContainer = (theme: Theme) => css`
  width: 100%;
  max-width: 880px; // 800px + 80px (40px padding on each side)

  height: 100%;

  > *:first-child {
    padding: 20px;

    @media (min-width: ${theme.breakpoints.medium}) {
      padding: 40px;
    }
  }
`;

export const lessonContent = css`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
`;

export const lessonDrawer = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
